import { useEffect, useRef, useState } from "react";
import KeidgeLogoPreto from "../assets/images/Logo-Keidge_preto-film.svg";
import { wpData } from "../data/wpAPI";

function Header() {
  const headerRef = useRef(null);
  const [topMenuItems, setTopMenuItems] = useState([]);
  const [menuStatus, setMenuStatus] = useState(null);

  // Fetch WP Menus
  useEffect(() => {
    const fetchTopMenu = async () => {
      try {
        const rawMenuData = await wpData("menu-items?menus=3");
        //console.log("raw data", rawMenuData);
        setTopMenuItems(rawMenuData);
      } catch (error) {
        console.error("Error fetching WordPress the Top Menu:", error);
      }
    };
    fetchTopMenu();
  }, []);
  const toSlugAdvanced = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[\W_]+/g, "-")
      .toLowerCase()
      .replace(/^-+|-+$/g, "");
  };

  // Set header height
  useEffect(() => {
    const setHeaderHeight = () => {
      if (headerRef.current) {
        const height = headerRef.current.offsetHeight;
        document.documentElement.style.setProperty(
          "--headerHeight",
          `${height}px`
        );
      }
    };
    setHeaderHeight();
  }, []);
  const toggleMenu = () => {
    menuStatus === null ? setMenuStatus("open") : setMenuStatus(null);
    // console.log(menuStatus);
  };
  return (
    <header ref={headerRef}>
      <div className="wrapper full-width">
        <div className="content-wrapper">
          <div className="logo-block" id="logo">
            <a href="#main-content">
              <svg width="0" height="0" id="svg-mask">
                <defs>
                  <clipPath id="logo-clip">
                    <rect id="logo-mask" x="0" y="32" width="79" height="32" />
                  </clipPath>
                </defs>
              </svg>
              <img
                src={KeidgeLogoPreto}
                alt="Logo Keidge Film - versão preta"
                className="logo"
                id="logo-dark"
                height="32"
                width="79"
              />
            </a>
          </div>
          <div className="menu-block">
            <button
              className={`toggle ${menuStatus === "open" ? "open" : ""}`}
              onClick={toggleMenu}
            >
              <span>menu</span>
            </button>
            <nav
              id="top-menu"
              {...(menuStatus === "open" ? { className: "open" } : {})}
            >
              <ul>
                {topMenuItems.map((menuItem) => {
                  const slug = toSlugAdvanced(menuItem.title.rendered);
                  return (
                    <li key={menuItem.id}>
                      <a
                        href={
                          menuItem.type === "custom" ? menuItem.url : `#${slug}`
                        }
                        onClick={toggleMenu}
                      >
                        {menuItem.title.rendered}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}
export default Header;
